import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import AuthTemplate from "../../templates/Auth";
import api from "../../services/api";

import Input from "../../components/Input";
import InputPassword from "../../components/InputPassword";
import Button from "../../components/Button";
import { logout, setToken, setUser, setPlano } from "../../services/auth";
import { renderError } from "../../helpers/errors";
import { getInitialPath } from "../../routes/privateRoutes";

export const Login = () => {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [recaptchaToken, setRecaptchaToken] = useState('');

    const recaptchaKey = process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY;

    useEffect(() => {
        logout();

        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/api.js?render=${recaptchaKey}`;
        script.async = true;
        document.body.appendChild(script);

        script.onload = () => {
            window.grecaptcha.ready(() => {
                window.grecaptcha
                    .execute(recaptchaKey, { action: 'login' })
                    .then(token => {
                        setRecaptchaToken(token);
                        setLoading(false);
                    })
                    .catch(error => {
                        console.error('Erro ao gerar token do reCAPTCHA:', error);
                        toast.error('Erro ao carregar o reCAPTCHA');
                        setLoading(false);
                    });
            });
        };

        return () => {
            document.body.removeChild(script);
        };
    }, [recaptchaKey]);

    const signIn = () => {
        if (!recaptchaToken) {
            toast.error("Erro ao carregar o reCAPTCHA.");
            return;
        }

        setLoading(true);

        api.post(`/login`, {
            email, 
            password,
            recaptcha_token: recaptchaToken
        }).then(res => {
            setToken(res.data.token);
            setUser(res.data.supplier);
            window.location.href="/";
        }).catch(error => {
            renderError(error);

            window.grecaptcha.ready(() => {
                window.grecaptcha
                    .execute(recaptchaKey, { action: 'login' })
                    .then(token => setRecaptchaToken(token))
                    .catch(error => {
                        console.error('Erro ao gerar token do reCAPTCHA:', error);
                        toast.error('Erro ao carregar o reCAPTCHA');
                    });
            });
        }).then(() => setLoading(false));
    }

    return (
        <AuthTemplate>
            <Input type={`email`} label={`E-mail`} change={setEmail} value={email} action={signIn} />
            <Input type={`password`} label={`Senha`} change={setPassword} value={password} action={signIn} />
            <Button type={`primary`} text={`Entrar`} full={true} svg={`arrow-right-white`} loading={loading} action={signIn} />
        </AuthTemplate>
    );
}

export default Login;